import { DialogProps } from '@mui/material';
import { FormContainer } from 'react-hook-form-mui';
import {
    AiSmartReplyPlan,
    AiSmartReplyPlanItem,
    CreateAiSmartReplyPlanItemRequest,
} from '../../../../../sic-lib/api/ai/types/Ai';
import { useAiCreateSmartReplyPlanItem } from '../../../../../sic-lib/api/hooks/useAiSmartReply';
import { aiCreateSmartReplyPlanItemDefaults } from '../../../../../sic-lib/defaults';
import { DrawerCommon } from '../../../../Shared/Drawer/DrawerCommon';
import { CreateSmartReplyPlanItemFormControls } from './CreateSmartReplyPlanItemFormControls';

interface Props extends DialogProps {
    parentItem: AiSmartReplyPlanItem | undefined;
    plan: AiSmartReplyPlan;
    onCancel: (event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onConfirm: (event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}
export function CreateSmartReplyPlanItemDrawer({
    parentItem,
    plan,
    onCancel,
    onConfirm,
    ...props
}: Props) {
    const {
        mutateAsync: createPlanItem,
        isPending: isLoading,
        isError,
        error,
    } = useAiCreateSmartReplyPlanItem();

    const handleCreate = async (formValues: CreateAiSmartReplyPlanItemRequest) => {
        //just disable repeats if repeatLimit is 0
        if (formValues.repeatLimit === 0) {
            formValues.repeats = false;
            formValues.repeatLimit = undefined;
        }

        await createPlanItem(formValues, {
            onSuccess: () => {
                onConfirm();
            },
        });
    };

    const handleClose = () => {
        onCancel();
    };

    return (
        <DrawerCommon
            title="Create SmartReply Item"
            handleOnClose={handleClose}
            width="1200px"
            {...props}
        >
            {!!parentItem && (
                <FormContainer<CreateAiSmartReplyPlanItemRequest>
                    defaultValues={{
                        ...aiCreateSmartReplyPlanItemDefaults,
                        parentPlanItemId: parentItem.planItemId,
                        planId: parentItem.planId,
                        clientId: plan.clientId,
                        userName: plan.userName,
                    }}
                    mode="all"
                    onSuccess={handleCreate}
                >
                    <CreateSmartReplyPlanItemFormControls
                        isLoading={isLoading}
                        isError={isError}
                        error={error}
                    />
                </FormContainer>
            )}
        </DrawerCommon>
    );
}
